import React from "react";
import { useParams } from "react-router-dom";
import { DownloadOutlined, FileOutlined } from "@ant-design/icons";
import { RESOURCE } from "../../../api/apiConstant";

export const DownloadConfirm = () => {
  const { fileId } = useParams();

  const handleDownload = () => {
    window.location.href = `${process.env.REACT_APP_AUTHENTICATION_API_URL}/${RESOURCE}/public/${fileId}`;
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center px-6">
      <div className="bg-white rounded-2xl shadow-2xl p-10 w-full max-w-md text-center">
        {/* Icon */}
        <div className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-blue-100 text-blue-600 text-3xl mb-6">
          <FileOutlined />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-semibold text-gray-800 mb-2">
          Download File
        </h1>

        {/* Description */}
        <p className="text-gray-500 mb-8">
          This file is ready to be downloaded. Click the button below to start
          the download.
        </p>

        {/* Button */}
        <button
          onClick={handleDownload}
          className="w-full flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg"
        >
          <DownloadOutlined />
          Download File
        </button>
      </div>
    </div>
  );
};
